import { Box, Typography } from '@mui/material'

interface RequestCardTitleProps {
  title: string
}

export const RequestCardTitle = ({ title }: RequestCardTitleProps) => {
  return (
    <Box
      sx={{
        mb: 4,
        pb: 2,
        backgroundColor: 'action.hover',
        borderRadius: 1,
        p: 1.5,
      }}
    >
      <Typography
        variant="h5"
        component="h3"
        sx={{
          fontWeight: 700,
          lineHeight: 1.3,
          fontSize: '1.25rem',
          color: 'text.primary',
        }}
      >
        {title}
      </Typography>
    </Box>
  )
}
